import MyService from '../../service';

const SlideApi = {
  uploadSlidePhoto: async (payload) => {
    try {
      const { data } = await MyService.postRequestData('/slide', payload).catch(
        (err) => console.log(err)
      );
      return data;
    } catch (e) {
      return [];
    }
  },

  getPathImage: async (photo) => {
    try {
      const { path } = await MyService.postRequestData(
        '/slide/photo',
        photo
      ).catch((err) => console.log(err));
      return path;
    } catch (e) {
      return [];
    }
  },

  getAllSlide: async () => {
    try {
      const { data } = await MyService.getRequestData('/slide');
      return data;
    } catch (error) {
      console.log(error);
    }
  },

  updateSlide: async (id, isActive) => {
    try {
      const { data } = await MyService.putRequestData(`/slide/${id}`, {
        is_active: isActive,
      });
      return data;
    } catch (err) {
      console.log(err);
    }
  },
};

export default SlideApi;
